import React, { useState, useEffect } from "react";
import PanelLayout from "layouts/PanelLayout";
import { TbSmartHome } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";
import "styles/teacher.css";

const ResultsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const subject = location.state?.subject || { title: "Fan nomi" };
  const [activeMenu, setActiveMenu] = useState(null);
  const [results, setResults] = useState([
    {
      id: 1,
      type: "Standart",
      title: "Qisqa ko‘paytirish formulalari",
      category: "Standart",
    },
    { id: 2, type: "Logic", title: "Tenglamalar testlari", category: "Logic" },
    {
      id: 3,
      type: "Standart",
      title: "Trigonometriya asoslari",
      category: "Standart",
    },
    { id: 4, type: "Logic", title: "Geometriya testlari", category: "Logic" },
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".menu-icon") &&
        !event.target.closest(".dropdown-menu")
      ) {
        setActiveMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOpenResultTable = (r) => {
    navigate(`/teacher/result-table/${r.id}`, { state: { test: r } });
  };
  return (
    <PanelLayout>
      <div className="subject-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span onClick={() => navigate("/teacher")}>
              <TbSmartHome
                style={{ fontSize: 20, color: "#01CC0D", cursor: "pointer" }}
              />
            </span>
            <span className="divider">/</span>
            <span onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
              {subject.title}
            </span>
            <span className="divider">/</span>
            <span className="current">Natijalar</span>
          </div>
        </div>

        <div className="test-grid">
          {results.map((r) => (
            <div
              key={r.id}
              className="test-box"
              onClick={() => handleOpenResultTable(r)}
            >
              <div className="test-top">
                <div className="badge-group">
                  <span className={`badge ${r.category?.toLowerCase()}`}>
                    {r.category}
                  </span>
                </div>

                {activeMenu === r.id && (
                  <div className="dropdown-menu">
                    <p onClick={() => alert("Ko‘rish bosildi")}>Ko‘rish</p>
                    <p onClick={() => alert("Tahrirlash bosildi")}>
                      Tahrirlash
                    </p>
                    <p>Tasdiqlash</p>
                    <p onClick={() => alert("O‘chirish bosildi")}>O‘chirish</p>
                    <p>Savol qo'shish</p>
                  </div>
                )}
              </div>

              <h4>{r.title}</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur. Nibh vel donec ultricies
                elementum.
              </p>
            </div>
          ))}
        </div>
      </div>
    </PanelLayout>
  );
};

export default ResultsPage;
